import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './StoreTransactionsPage.module.scss';
import IconBackArrow from '../../../assets/icons/store/icon_back_arrow.png';
import IconTowerLogoWhiteBg from '../../../assets/icons/store/icon_tower_logo_white_bg.png';
import IconPopOut from '../../../assets/icons/store/icon_pop_out.png';
import { Web3Context } from '../../../web3/Web3Context';
import IconTick from '../../../assets/icons/store/icon_tick.png';
import { useTranslation } from 'react-i18next';
import { fetchOrderHistory } from '../../../services/storeServices';
import { TokenContext } from '../../Context';

const StoreTransactionsPage = () => {
    const history = useHistory();
    const ORDERS_PER_PAGE = 10;
    const { selectedAccount } = useContext(Web3Context);
    const [userOrders, setUserOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [list, setList] = useState([]);
    // const [paginatedList, setPaginatedList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [t] = useTranslation();
    const [tokenState] = useContext(TokenContext);

    const middleEllipsis = (text) => {
        return `${text.slice(0, 12)}...${text.slice(-12)}`;
    }

    useEffect(() => {
        if (selectedAccount && tokenState.userId) {
            fetchOrders(currentPage);
        } else {
            setUserOrders([]);
        }
    }, [selectedAccount, tokenState.userId, currentPage]);

    const fetchOrders = async (currentPageValue) => {
        setLoading(true);
        let response = await fetchOrderHistory(selectedAccount, ORDERS_PER_PAGE, (currentPageValue-1)*ORDERS_PER_PAGE);
        if (response?.orders && response?.totalCount) {
            setUserOrders(response.orders);
            setTotalPages(Math.ceil(response.totalCount / ORDERS_PER_PAGE));
        }
        setLoading(false);
    }

    // useEffect(() => {
    //     setList(userOrders);
    // }, [userOrders])

    // useEffect(() => {
    //     let totalItems = list.length;
    //     if (totalItems > 0) {
    //         setCurrentPage(1);
    //     }
    //     setTotalPages(Math.ceil(totalItems / ORDERS_PER_PAGE));
    //     let paginatedData = list.slice(0, ORDERS_PER_PAGE);
    //     setPaginatedList(paginatedData);
    // }, [list])

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            // let initialItem = (pageNumber - 1) * ORDERS_PER_PAGE;
            // let finalItem = pageNumber * ORDERS_PER_PAGE;

            // let paginatedData = list.slice(
            //     initialItem,
            //     finalItem
            // );
            // setPaginatedList(paginatedData);
            setCurrentPage(pageNumber);
        }
    };

    const renderLoadingText = (
        <div className={styles.loading_screen}>
            <span className={styles.loading_text}>{t('LOADING_SCREEN')}</span>
        </div>
    );

    const renderNoItemsFound = (
        <div className={styles.no_items_found}>
            <span className={styles.no_items_found_text}>{'No Orders Found!'}</span>
        </div>
    );

    const renderSingleUserOrder = (userOrder, index) => {
        const txnDate = userOrder.txn_timestamp.slice(0,10);
        const itemName = userOrder.item_name;
        const itemPrice = parseInt(userOrder.item_total_amount / 10**18);
        const txnHash = middleEllipsis(userOrder.txn_hash);
        const orderStatus = userOrder.status.charAt(0).toUpperCase() + userOrder.status.slice(1);

        return (
                <tr key={`table-row-${index}`}>
                    <td className={styles.store_transactions_page_table_body_date}>{txnDate}</td>
                    <td className={styles.store_transactions_page_table_body_item}>{itemName}</td>
                    <td className={styles.store_transactions_page_table_body_price}>
                        <div className={styles.store_transactions_page_table_body_tower_logo}>
                            <img src={IconTowerLogoWhiteBg} alt="tower" />
                        </div>
                        &nbsp;
                        <div className={styles.store_transactions_page_table_body_price_text}>
                            {itemPrice}
                        </div>
                    </td>
                    <td className={styles.store_transactions_page_table_body_hash} >
                        <a href={`${process.env.REACT_APP_POLYGON_BLOCK_EXPLORER_URL}` + `tx/` + userOrder.txn_hash} target='_blank'>
                            <div className={styles.store_transactions_page_table_body_hash_text}>
                                {txnHash}
                            </div>
                            <div className={styles.txnhash_popout}>
                                <img src={IconPopOut} alt="redirect" />
                            </div>
                        </a>
                    </td>
                    <td className={styles.store_transactions_page_table_body_status}>
                        {(orderStatus === 'Completed')
                            ?
                            <>
                                <div className={styles.store_transactions_page_table_body_tick}>
                                    <img src={IconTick} alt="tick" />
                                </div>
                                <div className={styles.store_transactions_page_table_body_status_text}>
                                    {orderStatus}
                                </div>
                            </>
                            :
                            <div className={styles.store_transactions_page_table_body_status_text}>
                                {`${orderStatus}...`}
                            </div>
                        }
                    </td>
                </tr>
        )
    }

    const renderOrderHistoryDetails = (
        <>
            {
                userOrders && userOrders.length > 0 ? 
                    <table className={styles.store_transactions_page_table}>
                        <thead className={styles.store_transactions_page_table_header}>
                            <tr>
                                <th>{'Date'}</th>
                                <th>{'Items'}</th>
                                <th>{'Price'}</th>
                                <th>{'Hash'}</th>
                                <th>{'Status'}</th>
                            </tr>
                        </thead>
                        <tbody className={styles.store_transactions_page_table_body}>
                            {userOrders.map((userOrder, index) => {
                                return renderSingleUserOrder(userOrder, index);
                            })}
                        </tbody>
                    </table> :
                    renderNoItemsFound
            }
        </>
    );

    return (
        <div className={styles.store_transactions_page_wrapper}>
            <div className={styles.store_transactions_page_header}>
                <div className={styles.store_transactions_page_backbtn} onClick={() => history.goBack()}>
                    <div className={styles.store_transactions_page_backarrow}>
                        <img src={IconBackArrow} alt="back-arrow" />
                    </div>
                    <div className={styles.store_transactions_page_backbtn_text}>
                        <span>{'Back'}</span>
                    </div>
                </div>
                <div className={styles.store_transactions_page_history_title}>{'Order History'}</div>
            </div>

            <div className={styles.store_transactions_page_history}>
                {loading ?
                    renderLoadingText :
                    renderOrderHistoryDetails
                }
            </div>

            <div className={styles.pagination}>
                <div
                    className={`${styles.arrow_btn} ${styles.left}`}
                    onClick={() =>
                        handlePageChange(currentPage - 1)
                    }
                ></div>
                <div className={styles.page_number_container}>
                    {currentPage > 2 && (
                        <>
                            <div
                                className={styles.page_btn}
                                onClick={() =>
                                    handlePageChange(1)
                                }
                            >
                                1
                            </div>
                            <div className={styles.page_dots}>
                                ...
                            </div>
                        </>
                    )}

                    {currentPage - 1 > 0 && (
                        <div className={styles.page_btn} onClick={() => handlePageChange(currentPage - 1)}>
                            {currentPage - 1}
                        </div>
                    )}
                    <div className={`${styles.page_btn} ${styles.current_page}`}>
                        {currentPage}
                    </div>
                    {currentPage + 1 <= totalPages && (
                        <div className={styles.page_btn} onClick={() => handlePageChange(currentPage + 1)}>
                            {currentPage + 1}
                        </div>
                    )}

                    {currentPage < totalPages - 1 && (
                        <>
                            <div className={styles.page_dots}>
                                ...
                            </div>
                            <div
                                className={styles.page_btn}
                                onClick={() =>
                                    handlePageChange(totalPages)
                                }
                            >
                                {totalPages}
                            </div>
                        </>
                    )}
                </div>
                <div
                    className={`${styles.arrow_btn} ${styles.right}`}
                    onClick={() =>
                        handlePageChange(currentPage + 1)
                    }
                ></div>
            </div>
        </div>
    )
}

export { StoreTransactionsPage };
